const BASEENDPOINT = "/directorio/";


const DIRECTORIO_ENDPOINT = {

    /* EMPLEADOS */
    FILTRARTIPOS: BASEENDPOINT + "filtratipos",
    BUSCAREMPLEADO: BASEENDPOINT + "buscarempleado",
    DATOSEMPLEADOS: BASEENDPOINT + "datosempleados"
}

export default DIRECTORIO_ENDPOINT;